module.exports = __webpack_public_path__ + "img/image20.88808ece.png";